import { useBatchSkiptraceStore } from 'features/BatchSkiptrace/infra/views/BatchSkiptraceStore/BatchSkiptraceStoreLive'

export const useBatchSkiptraceAttemptState = () =>
  useBatchSkiptraceStore(store => store.attemptBatchSkiptrace.state)
